import { useEffect } from 'react';
import { useSharedValue, useAnimatedStyle, withTiming } from 'react-native-reanimated';

import { BADGE_ENTRANCE } from '@components/search/operations/components/StartJobPopup/components/SendStatus/constants';

interface UseManageSendStatusParams {
  isBadgeVisible: boolean;
}

export const useManageSendStatus = ({ isBadgeVisible }: UseManageSendStatusParams) => {
  const progress = useSharedValue(0);

  useEffect(() => {
    if (!isBadgeVisible) return;
    progress.value = 0;
    progress.value = withTiming(1, { duration: BADGE_ENTRANCE.duration });
  }, [isBadgeVisible, progress]);

  const badgeAnimatedStyle = useAnimatedStyle(() => ({
    opacity: progress.value,
    transform: [{ scale: BADGE_ENTRANCE.fromScale + (1 - BADGE_ENTRANCE.fromScale) * progress.value }],
  }));

  return { badgeAnimatedStyle };
};
